import React, { useEffect } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { endOfMonth, startOfMonth } from 'date-fns';
import { datePickerClass, toValidDate } from '../../../utilities/common';

const BenchmarkFilters = ({ startDate, endDate, onApply, isLoading }) => {

  const { t } = useTranslation();

  const { control, watch, reset, formState: { isDirty }, } = useForm({
    defaultValues: {
      startPeriod: toValidDate(startDate),
      endPeriod: toValidDate(endDate)
    }
  });

  const watchStart = watch('startPeriod');
  const watchEnd = watch('endPeriod');

  useEffect(() => {
    reset({
      startPeriod: toValidDate(startDate),
      endPeriod: toValidDate(endDate)
    });
  }, [startDate, endDate, reset]);

  const triggerChange = () => {
    if (!watchStart || !watchEnd) return;

    const normalizedStartDate = startOfMonth(watchStart);
    const normalizedEndDate = endOfMonth(watchEnd);

    onApply({
      startDate: normalizedStartDate,
      endDate: normalizedEndDate
    });

    reset({
      startPeriod: normalizedStartDate,
      endPeriod: normalizedEndDate
    });
  };

  return (
    <Card className="mb-4">
      <Card.Body>

        <Row>

          <Col md={4}>
            <Form.Group className="custom-form-control mb-0">
              <Form.Label>{t('Start Period')}</Form.Label>

              <Controller
                name="startPeriod"
                control={control}
                render={({ field, fieldState: { invalid } }) => (
                  <ReactDatePicker
                    showMonthYearPicker
                    dateFormat="MMM yyyy"
                    maxDate={watchEnd}
                    popperPlacement="bottom-end"
                    selected={toValidDate(field.value)}
                    onChange={(value) => field.onChange(value)}
                    {...datePickerClass(invalid)}
                  />
                )}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="custom-form-control mb-0">
              <Form.Label>{t('End Period')}</Form.Label>

              <Controller
                name="endPeriod"
                control={control}
                render={({ field, fieldState: { invalid } }) => (
                  <ReactDatePicker
                    showMonthYearPicker
                    dateFormat="MMM yyyy"
                    minDate={watchStart}
                    popperPlacement="bottom-end"
                    selected={toValidDate(field.value)}
                    onChange={(value) => field.onChange(value)}
                    {...datePickerClass(invalid)}
                  />
                )}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="custom-form-control mb-0">
              <Form.Label>{ }</Form.Label>
              <div style={{ padding: '0.375rem 0.75rem' }}>
                <Button
                  disabled={isLoading || !watchStart || !watchEnd || !isDirty}
                  variant="primary"
                  onClick={() => triggerChange()}
                >
                  {t('Apply')}
                </Button>
              </div>
            </Form.Group>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  );
};

export default BenchmarkFilters;
